import styled from 'styled-components';

const LabelManageResult = styled.div`
  flex: 1 auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .result-content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-right: 24px;
    .content-top-left {
      width: 730px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .top-bcg {
        width: 10px;
        height: 132px;
        background: #1565c0;
        box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.16);
        border-radius: 12px 0 0 12px;
      }
      .top-icon-bcg {
        width: 80px;
        height: 80px;
        /* background: ${(props) => (props.start ? '#616161' : '#1565C0')}; */
        background: ${(props) => (props.start ? '#1565C0' : '#616161')};
        display: flex;
        cursor: pointer;
        .top-icon {
          width: 47px;
          height: 47px;
          align-items: center;
          margin: auto;
        }
      }
      .top-content-wrap {
        /* height:100%; */
        background: #ffffff;
        box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.16),
          0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 0 12px 12px 0;
        padding: 25px 32px;
        width: 100%;
        word-break: break-all;
        min-height: 134px;
        .tooltip-wrap {
          display: flex;
          flex-direction: row;
          font-size: 24px;
          font-weight: 600;
          color: #212121;
          line-height: 33px;
          .tooltip-content {
            margin: -10px 0 0 5px;
          }
        }
        .content-bottom-list {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 27px;
          font-size: 16px;
          font-weight: 400;
          color: #616161;
          line-height: 22px;
          .list-regular,
          .list-edit,
          .list-download {
            border-right: 1px solid #cccccc;
          }
          .list-edit,
          .list-download,
          .list-like {
            display: flex;
            align-items: center;
          }
          .list-regular {
            padding-right: 114px;
            cursor: pointer;
          }
          .list-edit {
            padding: 0 35px 0 32px;
            gap: 13px;
            cursor: pointer;

            .list-edit-icon {
              cursor: pointer;
            }
          }
          .list-download {
            padding: 0 37px 0 32px;
            gap: 15px;
            .icon {
              cursor: pointer;
            }
          }
          .list-like {
            gap: 15px;
            padding-left: 32px;
            div {
              /* line-height:1; */
              cursor: pointer;
              height: 23px;
            }
          }
        }
      }
    }
    .content-top-right {
      width: 132px;
      height: 132px;
      background: ${(props) => (props.calculate ? '#1565C0' : '#FFFFFF')};
      cursor: ${(props) => (props.calculate ? 'pointer' : '')};
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      padding: 45px 0 4px;
      display: flex;
      flex-direction: column;
      gap: 14px;
      align-items: center;
      .right-icon {
        width: 35px;
        height: 49px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: ${(props) => (props.calculate ? '#fff' : '#CCCCCC')};
        line-height: 20px;
      }
    }
  }
  .result-list-wrap {
    background: #ffffff;
    width: 100%;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    margin-top: 24px;
    padding: 8px 32px;
    flex-grow: 1;
    flex: 1 auto;
    .tab-panel-top {
      margin: 48px 0;
      .label-people-num,
      .label-people-date {
        display: flex;
        flex-direction: row;
        .people-date-first {
          min-width: 120px;
        }
      }
      .label-people-num {
        font-size: 32px;
        font-weight: 600;
        color: #212121;
        line-height: 28px;
        span {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 28px;
        }
      }
      .label-people-date {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
        align-items: center;
        gap: 4px;
        margin-top: 8px;
        span {
          width: 8px;
          height: 8px;
          background: #1565c0;
          border-radius: 50%;
        }
      }
    }
    .label-history-search {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 48px;
      padding: 24px 0;
      border-bottom: 1px solid #cccccc;
      .history-search-left {
        flex: 1 auto;
        gap: 48px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .search-right {
        display: flex;
        flex-direction: row;
        gap: 16px;
      }
    }
    .label-table-wrap {
      /* max-width: 1000px; */
    }
  }
  .tab-panel {
    width: 100%;
    height: 100%;
    .MuiBox-root {
      height: 100%;
    }
    .panel-charts {
      /* min-height: 120px; */
      /* height:100%; */
    }
  }
  .multiple-select {
    margin-top: -18px;
  }
`;

export default LabelManageResult;
